import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigurationCompanyProductModel } from 'src/app/models/Configurations/ConfigurationCompanyProductModel';
import { TransactionEstornoResponse } from 'src/app/models/Sales/TransactionEstornoResponse';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { SalesService } from 'src/app/services/sales/sales.service';
import { SessionService } from 'src/app/services/session/session.service';

interface DialogData {
    cardTransactionId: number;
    nsu: number;
    estornoTransaction: MatTableDataSource<TransactionEstornoResponse>
}

@Component({
    selector: 'app-dialog-estorno-details',
    templateUrl: './dialog-estorno-details.component.html',
    styleUrls: ['./dialog-estorno-details.component.scss']
})
export class DialogEstornoDetailsComponent implements OnInit {

    @ViewChild('outerSort', { static: true }) sort!: MatSort;

    configProduct: ConfigurationCompanyProductModel[] = [];
    readonly displayedColumns: string[] = [
        'nsu',
        'cAut',
        'operator',
        'value',
        'date',
    ];
    readonly nameUser = this.sessionService.getDetails().fullName

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private configService: ConfigurationService,
        private salesService: SalesService,
        private sessionService: SessionService) { }

    async ngOnInit(): Promise<void> {
        this.data.estornoTransaction = new MatTableDataSource(await this.salesService.getEstornoTransaction(this.data.cardTransactionId));
        this.data.estornoTransaction.sort = this.sort;
    }

    formatNumberByCountry(value: number): string {
        return this.configService.formatNumberByCountry(value);
    }
}
